const digitsOnly = value => String(value || '').replace(/\D/g, '');

export const normalizeSalesPartyCountryCode = value =>
  digitsOnly(value) || '55';

export const formatSalesPartyPhone = (value, countryCode = '55') => {
  const code = normalizeSalesPartyCountryCode(countryCode);
  const digits = digitsOnly(value).slice(0, code === '55' ? 11 : 14);
  if (code !== '55' || digits.length <= 2) {
    return code === '55' && digits ? `(${digits}` : digits;
  }

  const areaCode = digits.slice(0, 2);
  const number = digits.slice(2);
  if (number.length <= 4) return `(${areaCode}) ${number}`;

  const separator = number.length > 8 ? 5 : 4;
  return `(${areaCode}) ${number.slice(0, separator)}-${number.slice(separator)}`;
};

export const salesPartyPhoneMaxLength = countryCode =>
  normalizeSalesPartyCountryCode(countryCode) === '55' ? 15 : 14;

export const isSalesPartyPhoneComplete = (countryCode, phone) => {
  const code = normalizeSalesPartyCountryCode(countryCode);
  const number = digitsOnly(phone);
  if (code === '55') return number.length >= 11;

  return number.length > 0 && `${code}${number}`.length >= 6;
};
